import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { formatFileSize } from 'vpl.tas';
import { holdCatalogPreloader, releaseCatalogPreloader } from 'vpl.tas';


export const ReviewsPage = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        formatFileSize: formatFileSize,
        lazyLoad(link ,append = true){

            link = link.split('#')[0];
            let arRoute = link.split('?');
            let params = 'get_json=Y';
            if(arRoute[1]){
                params += '&' + arRoute[1];
            }

            holdCatalogPreloader();
            $.ajax({
                url: arRoute[0] + '?' + params,
                method: 'GET',
                complete: () => releaseCatalogPreloader(),
                success: (response) => {
                    response = JSON.parse(response);
                    if(append){
                        this.reviewsData.ITEMS = [...this.items, ...response.struct[this.structKey].componentData.ITEMS];
                    }else{
                        this.reviewsData.ITEMS = response.struct[this.structKey].componentData.ITEMS;

                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(this.$el).offset().top - 70
                        }, 500);
                    }
                    this.reviewsData.PAGIN = response.struct[this.structKey].componentData.PAGIN;

                }
            });
        },
    },
    updated(){
        this.items = this.reviewsData.ITEMS;
    },
    mounted(){
        this.items = this.reviewsData.ITEMS;
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH']),
        reviewsData(){
            return this.struct[this.structKey].componentData;
        }
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS" class="section section--first">
    <div class="container">
        <div class="reviews__list">

            <div v-for="item in this.reviewsData.ITEMS" :key="item.ID" class="reviews__item">
                <div class="reviews__item-heading">
                    <div class="reviews__item-heading-leftside">
                        <div v-if="item.AUTHOR" class="reviews__item-name">
                            {{item.AUTHOR}}
                        </div>
                        <div v-if="item.POSITION" class="reviews__item-company">
                            {{item.POSITION}}
                        </div>
                    </div>
                    <div v-if="item.LOGO" class="reviews__item-logo">
                        <img class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.LOGO" alt="" title="">
                    </div>
                </div>
                <div class="reviews__item-text" v-html="item.REVIEW">
                </div>
                <div v-if="item.FILE" class="reviews__item-bottom">
                    <a :href="item.FILE.SRC" target="_blank" class="reviews__item-link">
                        <div class="reviews__item-link-img">
                            <svg class="ico ico-pdf" width="18" height="18" aria-hidden="true"><use xlink:href="#ico-pdf"></use></svg>
                            <svg class="ico ico-pdf-h hover" width="18" height="18" aria-hidden="true"><use xlink:href="#ico-pdf-h"></use></svg>
                        </div>
                        <div class="reviews__item-link-text">
                            {{item.FILE.ORIGINAL_NAME}}
                        </div>
                        <div class="reviews__item-link-size">
                            {{formatFileSize(item.FILE.FILE_SIZE)}}
                            <div class="reviews__item-link-icon">
                                <svg class="icon icon-download"><use xlink:href="#icon-download"></use></svg>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
             <div class="content-nav" v-if="this.reviewsData.PAGIN">
                <ul class="content-nav__list">
                    <template v-for="link in this.reviewsData.PAGIN">
                        <li v-if="link.type==='left_arrow'" class="content-nav__list-item content-nav__list-item--prev">
                            <a :href="link.link" @click.prevent="lazyLoad(link.link, false)" data-skip="y">
                                <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                            </a>
                        </li>
                        <li v-if="link.type==='number'" :class="{active: link.selected}" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.selected ? '#' : link.link">{{ link.text }}</a></li>
                        <li v-if="link.type==='dots'" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.link">...</a></li>
                        <li v-if="link.type==='right_arrow'" class="content-nav__list-item content-nav__list-item--next">
                            <a :href="link.link" data-skip="y" @click.prevent="lazyLoad(link.link, false)">
                                <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                            </a>
                        </li>
                    </template>
                </ul>
                <template v-for="link in this.reviewsData.PAGIN">
                    <a v-if="link.type==='showmore'" href="#" @click.prevent="lazyLoad(link.link)" class="btn btn--border">Показать ещё</a>
                </template>
            </div>
        </div>
    </div>
</section>
    `
}